import { useContext } from "react";
import { ActivitiesContext } from "../context/activities-context";

const MoreInfo = (props) => {
	const { setMoreInfoCard, setMoreInfoVisible } =
		useContext(ActivitiesContext);

	return (
		<footer className="c-fiche__footer">
			<a
				className="minimal"
				title={"Meer info over " + props.activity.name.nl}
			>
				{props.cta}<i className="fa-solid fa-arrow-right" aria-hidden="true"></i> 
			</a>
		</footer>
	);
};

export default MoreInfo;
